import { Typography } from "antd";
import { CustomerOrderCustomerItemInfo } from "../../../../../model/OrderManagement/CustomerOrder";
import FormatFunction from "../../../../../shared/utils/Fn";
import { ItemDescriptions } from "../../../Description/Item";
import { CustomDescriptions } from "../../../Description/index.styled";
import { Section } from "../index.styled";

interface RepairCustomerInfoFormProps {
  dataSource?: CustomerOrderCustomerItemInfo;
}

/**
 * 매장주문 > 고객 정보
 * @param param0
 * @returns
 */
export const RepairCustomerInfoForm: React.FC<RepairCustomerInfoFormProps> = ({
  dataSource,
}) => {
  /**
   * @notice 매장(crew)는 consumer 사용중이라 맞춤
   */
  return (
    <Section>
      <ItemDescriptions
        title={<Typography.Title level={5}>고객정보</Typography.Title>}
        labelStyle={{
          width: 100,
          fontWeight: 500,
        }}
        layout="horizontal"
        className="info"
      >
        <CustomDescriptions.Item label="고객명">
          {dataSource?.consumerName || "-"}
        </CustomDescriptions.Item>
        <CustomDescriptions.Item label="고객 휴대폰">
          {FormatFunction.regPhoneNumber(dataSource?.consumerPhone)}
        </CustomDescriptions.Item>
        <CustomDescriptions.Item label="요청사항">
          {dataSource?.orderMemo || "-"}
        </CustomDescriptions.Item>
      </ItemDescriptions>
    </Section>
  );
};
